import { api } from './api';
import type {
  VaultShare,
  SharedWithMe,
  CreateVaultShareRequest,
  UpdateVaultShareRequest,
  SetVaultKeyRequest,
} from '@/types/vault';

interface VaultShareListResponse {
  shares: VaultShare[];
}

interface SharedWithMeResponse {
  shares: SharedWithMe[];
}

interface VaultKeyResponse {
  vaultKeyEncrypted: string;
}

export const vaultShareService = {
  // As vault owner
  listVaultShares: (vaultId: string) =>
    api.get<VaultShareListResponse>(`/vault-shares?vaultId=${vaultId}`),

  createShare: (data: CreateVaultShareRequest) =>
    api.post<VaultShare>('/vault-shares', data),

  updateShare: (id: string, data: UpdateVaultShareRequest) =>
    api.patch<VaultShare>(`/vault-shares/${id}`, data),

  revokeShare: (id: string) => api.delete(`/vault-shares/${id}`),

  setVaultKey: (id: string, data: SetVaultKeyRequest) =>
    api.post(`/vault-shares/${id}/vault-key`, data),

  // As recipient
  listSharedWithMe: () =>
    api.get<SharedWithMeResponse>('/vault-shares/shared-with-me'),

  acceptShare: (id: string) => api.post(`/vault-shares/${id}/accept`),

  declineShare: (id: string) => api.post(`/vault-shares/${id}/decline`),

  getVaultKey: (id: string) =>
    api.get<VaultKeyResponse>(`/vault-shares/${id}/vault-key`),

  claimVaultKey: (id: string, data: SetVaultKeyRequest) =>
    api.post(`/vault-shares/${id}/claim-key`, data),

  getShareForVault: (vaultId: string) =>
    api.get<{
      id: string;
      vaultId: string;
      permission: string;
      hasVaultKey: boolean;
      vaultKeyEncrypted: string | null;
    }>(`/vault-shares/for-vault/${vaultId}`),

  // Access logs
  getAccessLogs: (vaultId: string, limit = 50, offset = 0) =>
    api.get<{
      logs: Array<{
        id: string;
        userId: string;
        userEmail: string;
        action: string;
        itemId: string | null;
        ipAddress: string | null;
        createdAt: string;
      }>;
      total: number;
    }>(`/vault-shares/access-logs?vaultId=${vaultId}&limit=${limit}&offset=${offset}`),
};
